<script lang="ts" setup>
import { useRoute } from "vue-router";
import { onMounted, ref } from "vue";
import { useMate } from "@/stores/mate";
import { Mate } from "@/types/entity";

const route = useRoute();
const mateStore = useMate();
const mate = ref<Mate>();
const isSaving = ref(false);

onMounted(() => {
  if (route.query.mateUuid) {
    mate.value = mateStore.mateMap.get(route.query.mateUuid as string)!;
  }
});
</script>

<template>
  <div class="w-full h-full grid grid-rows-[auto_1fr] overflow-hidden">
    <ThreadsNav show-back :show-center="false" />

    <TimelineModule
      v-if="mate"
      :entity-id="mate.id"
      entity-type="mate"
      :entity-uuid="mate.uuid"
      :universe-id="mate.universeId"
      @update:is-saving="isSaving = $event"
    />
  </div>
</template>
